import { render } from "./Attributes.vue?vue&type=template&id=219dbd85&scoped=true"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"

import "./Attributes.vue?vue&type=style&index=0&id=219dbd85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219dbd85"]])

export default __exports__